<template>
  <div class="apex-color-pinker-container">
    <el-button size="small" icon="el-icon-s-flag" circle />
    <el-color-picker
      v-model="color"
      :predefine="predefineColors"
      :disabled="colorDisabled"
      @change="colorChange"
      @click.native="colorClick"
    />
  </div>
</template>

<script>
import locale from '@/mixins/index'
import TableStore from '../utils/storage'
import _clonedeep from 'lodash.clonedeep'

export default {
  mixins: [locale],
  props: {
    rowKey: {
      type: String,
      default: ''
    },
    // 多选行数据
    selectionRows: {
      type: Array,
      default: () => []
    },
    storage: {
      type: [Boolean, String],
      default: true,
      required: false
    },
    storageNeedPrefix: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      color: '',
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        '#FF7800',
        '#fad400',
        '#00babd'
      ]
    }
  },
  computed: {
    colorDisabled() {
      return !this.selectionRows.length
    }
  },
  created() {
    const storedColors = this.getStorageColors()
    this.$emit('color-change', 'created', storedColors)
  },
  methods: {
    getStorageTable() {
      if (this.StorageTableStore == null) {
        this.StorageTableStore = new TableStore({ $router: this.$route, tableName: 'markRowColor', keyType: this.storage, storageNeedPrefix: this.storageNeedPrefix })
      }
      return this.StorageTableStore
    },
    getStorageColors() {
      return this.getStorageTable().getTableValue()
    },
    colorChange(color) {
      this.saveOptionsToStorage(this.selectionRows, color)
    },
    saveOptionsToStorage(rowData, color = null) {
      if (!Array.isArray(rowData)) {
        rowData = [rowData]
      }
      const tempArr = []
      const colors = this.getStorageColors()
      if (colors && colors.length > 0) {
        colors.forEach(item => {
          rowData.forEach(row => {
            if (item.key === row[this.rowKey]) {
              const target = {
                key: item.key,
                color
              }
              tempArr.push(target)
            }
          })
        })
        const cloneTempArr = _clonedeep(tempArr)
        colors.forEach(item => {
          const index = cloneTempArr.findIndex(temp => temp.key === item.key)
          if (index === -1) {
            tempArr.push(item)
          }
        })
        const cloneTempArr2 = _clonedeep(tempArr)
        rowData.forEach(item => {
          const index = cloneTempArr2.findIndex(temp => temp.key === item[this.rowKey])
          if (index === -1) {
            tempArr.push({
              key: item[this.rowKey],
              color
            })
          }
        })
      } else {
        rowData.forEach(row => {
          const target = {
            key: row[this.rowKey],
            color
          }
          tempArr.push(target)
        })
      }

      this.getStorageTable().updateTableValue(tempArr)
      this.$emit('color-change', color, tempArr)
    },
    // 清空缓存数据
    clearThisStorage() {
      this.getStorageTable().clearTableValue()
      this.$emit('color-change', '', [])
    },
    colorClick(e) {
      if (!this.selectionRows.length) {
        this.$message.warning(this.t('table.toolbar.colorPickerMessage'))
      }
    }
  }
}

</script>

<style lang='scss' scoped>
.apex-color-pinker-container {
  display: inline-block;
  position: relative;
  padding: 0 10px;
  .el-color-picker {
    position: absolute;
    top: 0;
    left: 10px;
    opacity: 0;
  }
}
</style>
